export const newAbsenceButtonClasses = {
  requestButton: {
    display: 'flex',
    alignItems: 'center',
    height: 'fit-content',
    gap: '4px',
    padding: '9px 22px',
  },
}
